/* Publish by EComposer at 2026-10-27 08:15:12*/
;try{
 (function(){
  "use strict";
  if(window.__astroyaRunesTasBoot){ return; }
  window.__astroyaRunesTasBoot = true;
  console.log("[Astroya] Tirage runes tas JS charge");

  /* ====== CONFIG ====== */
  var POOL_COUNT   = 13;   /* galets dans le tas */
  var PICK_COUNT   = 3;
  var MAX_DRAWS    = 5;
  var GATE_AFTER   = 2;
  var LS_DRAWS     = "astroya_runes_tas_draws";
  var LS_EMAIL     = "astroya_runes_email";   /* ancienne inscription (avant n8n) : autorise les tirages, pre-remplit la popup */

  /* ---- n8n : interpretation complete + inscription Klaviyo (liste Tirage de runes + newsletter).
     Aucune cle ni liste Klaviyo ici. Le tirage et la lecture rune par rune restent dans la page. ---- */
  var API = "https://n8n.astroya.fr/webhook/tirage-runes";
  /* MODE STRICT : l'interpretation complete est reservee aux personnes inscrites via la popup de CETTE page.
     A l'inscription, n8n remet un JETON SIGNE (impossible a fabriquer sans la cle secrete de n8n).
     Email + jeton gardes 2 fois : localStorage + cookie sur tout astroya.fr (avec et sans www). */
  var K_EMAIL = "astroya_rnt_email", K_TOKEN = "astroya_rnt_token", COOKIE_DAYS = 400;
  /* emails d'autres outils Astroya : servent UNIQUEMENT a pre-remplir la popup (jamais a debloquer) */
  var PREFILL_KEYS = ["astroya_runes_email","astroya_lnd_email","astroya_ttm_email","astroya_tarologie_email","astroya_t3c_email","astroya_bel_email","astroya_ral_email","astroya_newsletter_email","astroya_amour_email_v2","astroya_boule_email_v2","astroya_pendule_email_v2","astroya_tarot_oui_non_email_v2"];

  function cookieGet(k){
    try{
      var parts = document.cookie ? document.cookie.split("; ") : [];
      for(var i=0;i<parts.length;i++){ var p = parts[i].split("="); if(p[0] === k){ return decodeURIComponent(p.slice(1).join("=")); } }
    }catch(e){}
    return "";
  }
  function cookieSet(k, v){
    try{
      var dom = /(^|\.)astroya\.fr$/.test(location.hostname) ? "; domain=.astroya.fr" : "";
      var dt = new Date(); dt.setTime(dt.getTime() + COOKIE_DAYS * 864e5);
      document.cookie = k + "=" + encodeURIComponent(v) + "; expires=" + dt.toUTCString() + "; path=/" + dom + "; SameSite=Lax" + (location.protocol === "https:" ? "; Secure" : "");
    }catch(e){}
  }
  function lsGet(k){ try{ return window.localStorage.getItem(k) || ""; }catch(e){ return ""; } }
  function lsSet(k, v){ try{ window.localStorage.setItem(k, v); }catch(e){} }
  function store(k, v){ if(v){ lsSet(k, v); cookieSet(k, v); } }
  function readKey(k){
    var v = lsGet(k) || cookieGet(k);
    if(v){ if(!lsGet(k)){ lsSet(k, v); } if(!cookieGet(k)){ cookieSet(k, v); } }
    return v;
  }
  function getAuth(){ return { email: readKey(K_EMAIL), token: readKey(K_TOKEN) }; }
  function saveAuth(email, token){ store(K_EMAIL, email); store(K_TOKEN, token); }
  function knownEmail(){
    var a = getAuth(); if(a.email){ return a.email; }
    for(var i=0;i<PREFILL_KEYS.length;i++){ var v = lsGet(PREFILL_KEYS[i]); if(v){ return v; } }
    return "";
  }
  function ask(payload){
    var ctrl = (typeof AbortController !== "undefined") ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function(){ ctrl.abort(); }, 15000) : null;
    return fetch(API, { method:"POST", headers:{ "Content-Type":"application/json" }, body:JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined })
      .then(function(r){ if(!r.ok){ throw new Error("http " + r.status); } return r.json(); })
      .then(function(d){
        if(timer){ clearTimeout(timer); }
        var data = (d && d.length) ? d[0] : d;
        if(!data || data.ok !== true){ var er = new Error("refus"); er.code = (data && data.error) || ""; throw er; }
        return data;
      })["catch"](function(err){ if(timer){ clearTimeout(timer); } throw err; });
  }

  var POSITIONS = ["Pass\u00e9", "Pr\u00e9sent", "Futur"];

  /* [IMG] ====== MAPPING IMAGES CARTES ======
     Chaque rune -> handle de fichier webp sur le CDN Shopify.
     Pattern strict : rune_{handle}.webp
     Tant que le webp n'existe pas, onerror bascule sur le galet SVG (fallback auto). */
  var CDN_RUNE = "https://cdn.shopify.com/s/files/1/0793/7058/4409/files/";
  var RUNE_IMG = {
    "Fehu":"fehu", "Uruz":"uruz", "Thurisaz":"thurisaz", "Ansuz":"ansuz",
    "Raidho":"raidho", "Kenaz":"kenaz", "Gebo":"gebo", "Wunjo":"wunjo",
    "Hagalaz":"hagalaz", "Nauthiz":"nauthiz", "Isa":"isa", "Jera":"jera",
    "Eihwaz":"eihwaz", "Perthro":"perthro", "Algiz":"algiz", "Sowilo":"sowilo",
    "Tiwaz":"tiwaz", "Berkana":"berkana", "Ehwaz":"ehwaz", "Mannaz":"mannaz",
    "Laguz":"laguz", "Ingwaz":"ingwaz", "Dagaz":"dagaz", "Othala":"othala"
  };
  function runeImgUrl(name){
    var h = RUNE_IMG[name];
    if(!h){ return ""; }
    return CDN_RUNE + "rune_" + h + ".webp";
  }

  /* [LIENS] page fille de chaque rune */
  function runePageUrl(name){
    var h = RUNE_IMG[name];
    return h ? "https://www.astroya.fr/pages/rune-" + h + "-signification" : "";
  }

  /* ====== 24 RUNES ====== */
  var RUNES = [
    {g:"\u16a0", n:"Fehu", kw:"Abondance", txt:"Prosp\u00e9rit\u00e9 et ressources qui fructifient.", mean:"Fehu est la rune de la richesse gagn\u00e9e et de l'\u00e9nergie qui circule. Elle annonce l'abondance mat\u00e9rielle et spirituelle, mais rappelle que ce qui est acquis doit \u00eatre entretenu et partag\u00e9.", dom:"Argent, prosp\u00e9rit\u00e9, r\u00e9ussite mat\u00e9rielle", adv:"Cultive la gratitude et fais circuler ton \u00e9nergie plut\u00f4t que de la retenir.", stone:"Citrine"},
    {g:"\u16a2", n:"Uruz", kw:"Force vitale", txt:"\u00c9nergie brute, sant\u00e9 et courage instinctif.", mean:"Uruz incarne la puissance de l'aurochs sauvage : vitalit\u00e9, endurance et courage instinctif. Elle appelle \u00e0 mobiliser ta force int\u00e9rieure pour franchir un cap.", dom:"Sant\u00e9, vitalit\u00e9, force int\u00e9rieure", adv:"Ose agir depuis ta puissance brute, sans la brider.", stone:"\u0152il de tigre"},
    {g:"\u16a6", n:"Thurisaz", kw:"Protection", txt:"D\u00e9fense, limites \u00e0 poser, force qui prot\u00e8ge.", mean:"Thurisaz est l'\u00e9pine protectrice : une force de d\u00e9fense qui \u00e9carte les dangers. Elle invite \u00e0 poser des limites claires et \u00e0 te prot\u00e9ger.", dom:"Protection, limites, d\u00e9fense", adv:"Pose tes limites : dire non est un acte d'amour de soi.", stone:"Tourmaline noire"},
    {g:"\u16a8", n:"Ansuz", kw:"Communication", txt:"Message, inspiration, parole juste \u00e0 venir.", mean:"Ansuz est la rune d'Odin, celle de la parole sacr\u00e9e et de l'inspiration. Elle annonce un message important, une prise de conscience ou une communication d\u00e9cisive.", dom:"Communication, sagesse, messages", adv:"\u00c9coute les signes et exprime ta v\u00e9rit\u00e9 avec clart\u00e9.", stone:"Lapis-lazuli"},
    {g:"\u16b1", n:"Raidho", kw:"Voyage", txt:"Mouvement juste, progression vers un but.", mean:"Raidho est le voyage et le chemin : le mouvement juste vers un objectif. Elle parle de progression, de rythme et de d\u00e9cisions qui te mettent en route.", dom:"Voyage, d\u00e9cision, chemin de vie", adv:"Avance \u00e0 ton rythme, sans pr\u00e9cipitation ni immobilisme.", stone:"Aventurine"},
    {g:"\u16b2", n:"Kenaz", kw:"R\u00e9v\u00e9lation", txt:"Clart\u00e9, inspiration cr\u00e9ative, lumi\u00e8re int\u00e9rieure.", mean:"Kenaz est la torche qui \u00e9claire : la connaissance, l'inspiration et le feu cr\u00e9ateur. Elle annonce une r\u00e9v\u00e9lation ou un regain de clart\u00e9.", dom:"Cr\u00e9ativit\u00e9, clart\u00e9, connaissance", adv:"Suis ton inspiration : la lumi\u00e8re est d\u00e9j\u00e0 en toi.", stone:"Cornaline"},
    {g:"\u16b7", n:"Gebo", kw:"Don & union", txt:"\u00c9change \u00e9quilibr\u00e9, cadeau, union des c\u0153urs.", mean:"Gebo est le don et l'union : un \u00e9change \u00e9quilibr\u00e9, un cadeau, une rencontre. En amour, c'est une rune tr\u00e8s favorable qui parle de r\u00e9ciprocit\u00e9.", dom:"Amour, union, partage", adv:"Ouvre-toi au partage : donner et recevoir s'\u00e9quilibrent.", stone:"Quartz rose"},
    {g:"\u16b9", n:"Wunjo", kw:"Joie", txt:"Bonheur, harmonie et r\u00e9compense m\u00e9rit\u00e9e.", mean:"Wunjo est la joie pure : bonheur, harmonie et r\u00e9compense apr\u00e8s l'effort. Elle annonce une p\u00e9riode heureuse et align\u00e9e.", dom:"Bonheur, harmonie, r\u00e9ussite", adv:"C\u00e9l\u00e8bre les petites victoires : la joie attire la joie.", stone:"Citrine"},
    {g:"\u16ba", n:"Hagalaz", kw:"Transformation", txt:"Bouleversement qui nettoie et pr\u00e9pare le neuf.", mean:"Hagalaz est la gr\u00eale : un bouleversement soudain qui nettoie et pr\u00e9pare un renouveau. Inconfortable mais n\u00e9cessaire, elle balaie l'ancien.", dom:"Changement, rupture, renouveau", adv:"Accueille le changement : il fait place au neuf.", stone:"Obsidienne"},
    {g:"\u16be", n:"Nauthiz", kw:"N\u00e9cessit\u00e9", txt:"Patience, contrainte qui enseigne, r\u00e9silience.", mean:"Nauthiz est le besoin et la contrainte : une \u00e9preuve qui enseigne la patience et la r\u00e9silience. Elle invite \u00e0 identifier l'essentiel.", dom:"Patience, r\u00e9silience, le\u00e7ons", adv:"Ne force pas : concentre-toi sur ce qui est vraiment essentiel.", stone:"H\u00e9matite"},
    {g:"\u16c1", n:"Isa", kw:"Pause", txt:"Gel, attente, temps d'observer avant d'agir.", mean:"Isa est la glace : un temps d'arr\u00eat, de gel et d'introspection. Elle demande de ralentir, d'observer et de laisser d\u00e9canter avant d'agir.", dom:"Pause, introspection, attente", adv:"Ralentis : ce temps d'arr\u00eat clarifie ta vision.", stone:"Cristal de roche"},
    {g:"\u16c3", n:"Jera", kw:"R\u00e9colte", txt:"Cycles, patience f\u00e9conde, fruits qui m\u00fbrissent.", mean:"Jera est la r\u00e9colte : le cycle des saisons et la r\u00e9compense du temps. Ce que tu as sem\u00e9 arrive \u00e0 maturit\u00e9. Rune tr\u00e8s favorable au travail.", dom:"Travail, r\u00e9compense, cycles", adv:"Fais confiance au temps : ta r\u00e9colte approche.", stone:"Jade"},
    {g:"\u16c7", n:"Eihwaz", kw:"Stabilit\u00e9", txt:"Ancrage profond, solidit\u00e9 face aux \u00e9preuves.", mean:"Eihwaz est l'if, l'axe du monde : ancrage profond et solidit\u00e9 face aux \u00e9preuves. Elle relie le visible et l'invisible et offre une force durable.", dom:"Ancrage, stabilit\u00e9, protection", adv:"Reste ancr\u00e9 dans tes valeurs, quoi qu'il arrive.", stone:"Jaspe rouge"},
    {g:"\u16c8", n:"Perthro", kw:"Myst\u00e8re", txt:"Destin cach\u00e9, intuition, r\u00e9v\u00e9lation \u00e0 venir.", mean:"Perthro est le gobelet du destin : les myst\u00e8res, le hasard et ce qui est encore cach\u00e9. Elle annonce une r\u00e9v\u00e9lation ou une surprise du destin.", dom:"Destin, intuition, myst\u00e8re", adv:"Reste ouvert \u00e0 l'inattendu : le destin joue en coulisses.", stone:"Labradorite"},
    {g:"\u16c9", n:"Algiz", kw:"Protection divine", txt:"Bouclier spirituel, guidance et s\u00e9curit\u00e9.", mean:"Algiz est le bouclier et l'\u00e9lan : une protection spirituelle puissante. Elle t'entoure d'une guidance sup\u00e9rieure et t'invite \u00e0 suivre ton intuition.", dom:"Protection, spiritualit\u00e9, guidance", adv:"Fais confiance \u00e0 ton intuition protectrice.", stone:"Am\u00e9thyste"},
    {g:"\u16cb", n:"Sowilo", kw:"Victoire", txt:"Soleil, r\u00e9ussite, \u00e9nergie qui m\u00e8ne au succ\u00e8s.", mean:"Sowilo est le soleil : victoire, r\u00e9ussite et \u00e9nergie vitale rayonnante. Rune extr\u00eamement positive, elle illumine tes projets et dissipe les doutes.", dom:"Succ\u00e8s, \u00e9nergie, r\u00e9ussite", adv:"Avance avec confiance : le soleil brille sur toi.", stone:"Pierre de soleil"},
    {g:"\u16cf", n:"Tiwaz", kw:"Courage", txt:"Justice, honneur, courage du guerrier.", mean:"Tiwaz est la rune du guerrier Tyr : justice, honneur et courage. Elle soutient les d\u00e9cisions justes et les combats men\u00e9s avec int\u00e9grit\u00e9.", dom:"Courage, justice, d\u00e9cision", adv:"D\u00e9fends tes convictions avec honneur et int\u00e9grit\u00e9.", stone:"Grenat"},
    {g:"\u16d2", n:"Berkana", kw:"Renaissance", txt:"Nouveaux d\u00e9buts, douceur, croissance.", mean:"Berkana est le bouleau, la d\u00e9esse-m\u00e8re : naissance, douceur et nouveaux commencements. Elle prot\u00e8ge ce qui \u00e9merge et nourrit la croissance.", dom:"Amour, renaissance, famille", adv:"Prends soin avec douceur de ce qui commence.", stone:"Pierre de lune"},
    {g:"\u16d6", n:"Ehwaz", kw:"Mouvement", txt:"Progr\u00e8s, confiance, coop\u00e9ration fertile.", mean:"Ehwaz est le cheval : mouvement, progr\u00e8s et coop\u00e9ration de confiance. Elle parle de partenariats fertiles et d'avanc\u00e9es harmonieuses.", dom:"Progr\u00e8s, partenariat, confiance", adv:"Avance en partenariat : la confiance ouvre la voie.", stone:"Turquoise"},
    {g:"\u16d7", n:"Mannaz", kw:"Soi", txt:"Identit\u00e9, conscience de soi, \u00e9quilibre int\u00e9rieur.", mean:"Mannaz est l'humain : le soi, la conscience de son identit\u00e9 et l'\u00e9quilibre int\u00e9rieur. Elle invite \u00e0 mieux te conna\u00eetre pour trouver la r\u00e9ponse.", dom:"Soi, identit\u00e9, \u00e9quilibre", adv:"La r\u00e9ponse est en toi : apprends \u00e0 mieux te conna\u00eetre.", stone:"Am\u00e9thyste"},
    {g:"\u16da", n:"Laguz", kw:"Intuition", txt:"Eau, flux \u00e9motionnel, intuition qui guide.", mean:"Laguz est l'eau : le flux \u00e9motionnel, l'intuition et les r\u00eaves. Elle invite \u00e0 te laisser porter par ton ressenti plut\u00f4t que par le mental.", dom:"Intuition, \u00e9motions, r\u00eaves", adv:"Suis ton ressenti : l'intuition te guide justement.", stone:"Aigue-marine"},
    {g:"\u16dc", n:"Ingwaz", kw:"Fertilit\u00e9", txt:"Potentiel en gestation, projet qui m\u00fbrit.", mean:"Ingwaz est la graine : fertilit\u00e9, potentiel en gestation et projet qui m\u00fbrit en silence. Elle annonce une naissance ou un aboutissement proche.", dom:"Fertilit\u00e9, projets, potentiel", adv:"Laisse m\u00fbrir tes id\u00e9es : la graine deviendra fruit.", stone:"Quartz rose"},
    {g:"\u16de", n:"Dagaz", kw:"\u00c9veil", txt:"Aube, perc\u00e9e lumineuse, changement positif.", mean:"Dagaz est l'aube : la perc\u00e9e lumineuse, l'\u00e9veil et le changement positif. Elle annonce une bascule heureuse, un nouveau jour qui se l\u00e8ve.", dom:"\u00c9veil, renouveau, clart\u00e9", adv:"Accueille le renouveau : une nouvelle aube se l\u00e8ve.", stone:"Cristal de roche"},
    {g:"\u16df", n:"Othala", kw:"H\u00e9ritage", txt:"Racines, foyer, valeurs qui nourrissent.", mean:"Othala est le domaine ancestral : l'h\u00e9ritage, le foyer et les valeurs qui te nourrissent. Elle invite \u00e0 te reconnecter \u00e0 tes racines et \u00e0 ce qui compte vraiment.", dom:"Famille, h\u00e9ritage, racines", adv:"Reconnecte-toi \u00e0 tes racines et \u00e0 tes valeurs.", stone:"Jaspe"}
  ];

  var RUNE_PATHS = {
    "Fehu":[[30,15,30,90],[30,25,55,15],[30,45,55,35]],
    "Uruz":[[28,90,28,20],[28,20,55,35],[55,35,55,90]],
    "Thurisaz":[[32,12,32,92],[32,35,52,50],[52,50,32,65]],
    "Ansuz":[[32,12,32,92],[32,28,55,40],[32,45,55,57]],
    "Raidho":[[32,12,32,92],[32,15,52,25],[52,25,32,45],[32,45,54,92]],
    "Kenaz":[[30,20,52,50],[52,50,30,80]],
    "Gebo":[[25,18,60,85],[60,18,25,85]],
    "Wunjo":[[32,12,32,92],[32,15,55,28],[55,28,32,42]],
    "Hagalaz":[[28,15,28,88],[57,15,57,88],[28,45,57,58]],
    "Nauthiz":[[35,15,35,90],[22,42,52,62]],
    "Isa":[[40,12,40,92]],
    "Jera":[[30,18,45,32],[45,32,30,46],[52,55,38,68],[38,68,52,82]],
    "Eihwaz":[[38,15,38,88],[38,15,52,26],[38,88,24,77]],
    "Perthro":[[30,15,30,90],[30,15,52,25],[30,90,52,80],[52,25,50,50],[50,50,52,80]],
    "Algiz":[[40,20,40,92],[40,35,22,18],[40,35,58,18]],
    "Sowilo":[[52,15,32,40],[32,40,52,62],[52,62,32,85]],
    "Tiwaz":[[40,25,40,92],[40,25,26,42],[40,25,54,42]],
    "Berkana":[[32,12,32,92],[32,15,54,27],[54,27,32,42],[32,45,54,60],[54,60,32,75]],
    "Ehwaz":[[28,15,28,90],[57,15,57,90],[28,20,42,45],[42,45,57,20]],
    "Mannaz":[[28,15,28,90],[57,15,57,90],[28,20,57,50],[57,20,28,50]],
    "Laguz":[[34,12,34,90],[34,15,54,32]],
    "Ingwaz":[[40,25,55,50],[55,50,40,75],[40,75,25,50],[25,50,40,25]],
    "Dagaz":[[25,20,25,80],[60,20,60,80],[25,20,60,80],[25,80,60,20]],
    "Othala":[[40,15,55,38],[55,38,40,58],[40,58,25,38],[25,38,40,15],[40,58,25,88],[40,58,55,88]]
  };

  /* dessine une rune en traits vectoriels (aucune dependance de police) */
  function runeMarkup(name, color, stroke){
    var segs = RUNE_PATHS[name];
    if(!segs){ return ""; }
    var sw = stroke || 7;
    var lines = "";
    for(var i=0;i<segs.length;i++){
      var s = segs[i];
      lines += '<line x1="'+s[0]+'" y1="'+s[1]+'" x2="'+s[2]+'" y2="'+s[3]+'" stroke="'+color+'" stroke-width="'+sw+'" stroke-linecap="round" stroke-linejoin="round"/>';
    }
    return lines;
  }

  /* [IMG] ====== CARTE-IMAGE (avec fallback SVG rune vectorielle) ====== */
  function runeImg(rune, cls){
    var url = runeImgUrl(rune.n);
    var svgFallback = '<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">'
      + runeMarkup(rune.n, "#e7d4ac", 7) + '</svg>';
    var fb = svgFallback.replace(/"/g, "&quot;");
    var alt = "Rune " + rune.n + " \u2013 " + rune.kw;
    return '<div class="rnt-card-img '+(cls||"")+'">'
      + '<img src="'+url+'" alt="'+alt+'" loading="lazy" decoding="async" '
      + 'onerror="this.onerror=null;this.parentNode.classList.add(\'rnt-card-fb\');this.parentNode.innerHTML=\''+fb+'\';" />'
      + '</div>';
  }

  /* formes de galets (chemins SVG patatoides varies) */
  var STONE_SHAPES = [
    "M75 8 C104 6 138 26 140 55 C142 82 118 112 78 113 C44 114 12 96 10 62 C8 32 46 10 75 8 Z",
    "M75 10 C100 6 136 24 139 52 C142 80 120 110 80 112 C48 114 11 98 11 64 C11 34 50 14 75 10 Z",
    "M75 9 C106 8 136 24 141 56 C145 84 116 110 76 111 C42 112 9 94 12 60 C14 30 47 11 75 9 Z",
    "M75 11 C98 7 133 22 140 53 C146 83 121 109 78 111 C43 113 13 95 10 61 C8 31 52 15 75 11 Z"
  ];
  /* teintes ardoise variees (clair, moyen, fonce) */
  var STONE_TONES = [
    ["#8a949a","#6b767d","#49545b"],
    ["#818b92","#616c73","#434e55"],
    ["#939ca1","#727d84","#4f5a61"],
    ["#78828a","#5a656c","#3d4850"]
  ];

  var $ = function(id){ return document.getElementById(id); };
  var fanRunes=[], picked=[], busy=false, pebbleSeed=0;
  /* [WOW] etat du carousel inline + memoire des galets pioches (pour l'effet de vol) */
  var lastChosen = [];
  var carDraw = { arr:[], idx:0, host:"rntDrawCarousel" };

  function todayKey(){ var d=new Date(); return d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate(); }
  function getDraws(){ try{ var r=window.localStorage.getItem(LS_DRAWS); if(!r) return 0; var o=JSON.parse(r); if(o&&o.day===todayKey()&&typeof o.count==="number") return o.count; return 0; }catch(e){ return 0; } }
  function setDraws(n){ try{ window.localStorage.setItem(LS_DRAWS, JSON.stringify({day:todayKey(),count:n})); }catch(e){} }
  function getEmail(){ return getAuth().email || lsGet(LS_EMAIL); }
  function shuffle(arr){ var a=arr.slice(); for(var i=a.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)); var t=a[i]; a[i]=a[j]; a[j]=t; } return a; }
  function rand(a,b){ return a + Math.random()*(b-a); }

  /* ====== SVG GALET ====== */
  function stoneSVG(rune, opts){
    pebbleSeed++;
    var uid = "s"+pebbleSeed;
    var shape = STONE_SHAPES[Math.floor(Math.random()*STONE_SHAPES.length)];
    var tone  = STONE_TONES[Math.floor(Math.random()*STONE_TONES.length)];
    var seed  = Math.floor(rand(1,90));
    var reveal = opts && opts.reveal;

    var runeFill1 = reveal ? "#e7d4ac" : "#3a444a";
    var runeOp2   = reveal ? "0.0" : "0.5";
    var runeGlow  = reveal ? ' style="filter:drop-shadow(0 0 4px rgba(205,171,110,.7))"' : '';

    var back = '<div class="rnt-face rnt-back"><svg viewBox="0 0 150 120" xmlns="http://www.w3.org/2000/svg">'
      + '<defs>'
      + '<radialGradient id="g'+uid+'b" cx="45%" cy="38%" r="72%"><stop offset="0%" stop-color="'+tone[0]+'"/><stop offset="50%" stop-color="'+tone[1]+'"/><stop offset="100%" stop-color="'+tone[2]+'"/></radialGradient>'
      + '<filter id="n'+uid+'b" x="-20%" y="-20%" width="140%" height="140%"><feTurbulence type="fractalNoise" baseFrequency="0.82" numOctaves="4" seed="'+seed+'" result="nz"/><feColorMatrix in="nz" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.42 0" result="na"/><feComposite in="na" in2="SourceGraphic" operator="in" result="gr"/><feBlend in="SourceGraphic" in2="gr" mode="multiply"/></filter>'
      + '</defs>'
      + '<path d="'+shape+'" fill="url(#g'+uid+'b)" filter="url(#n'+uid+'b)" stroke="#39434a" stroke-width="1.5"/>'
      + '<ellipse cx="55" cy="40" rx="32" ry="18" fill="#ffffff" opacity="0.08"/>'
      + '<circle cx="95" cy="55" r="2.2" fill="#3a444a" opacity="0.4"/><circle cx="60" cy="80" r="1.6" fill="#3a444a" opacity="0.35"/><circle cx="45" cy="55" r="1.1" fill="#e7d4ac" opacity="0.22"/>'
      + '</svg></div>';

    var front = '<div class="rnt-face rnt-front"><svg viewBox="0 0 150 120" xmlns="http://www.w3.org/2000/svg">'
      + '<defs>'
      + '<radialGradient id="g'+uid+'f" cx="42%" cy="35%" r="75%"><stop offset="0%" stop-color="'+tone[0]+'"/><stop offset="45%" stop-color="'+tone[1]+'"/><stop offset="100%" stop-color="'+tone[2]+'"/></radialGradient>'
      + '<filter id="n'+uid+'f" x="-20%" y="-20%" width="140%" height="140%"><feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="3" seed="'+(seed+11)+'" result="nz"/><feColorMatrix in="nz" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0" result="na"/><feComposite in="na" in2="SourceGraphic" operator="in" result="gr"/><feBlend in="SourceGraphic" in2="gr" mode="multiply"/></filter>'
      + '<filter id="e'+uid+'f"><feDropShadow dx="0" dy="1.2" stdDeviation="0.4" flood-color="#20272c" flood-opacity="0.8"/></filter>'
      + '</defs>'
      + '<path d="'+shape+'" fill="url(#g'+uid+'f)" filter="url(#n'+uid+'f)" stroke="#3c464c" stroke-width="1.5"/>'
      + '<ellipse cx="52" cy="38" rx="30" ry="17" fill="#ffffff" opacity="0.10"/>'
      + '<g filter="url(#e'+uid+'f)"'+runeGlow+' transform="translate(43,26) scale(0.64)">'+runeMarkup(rune.n, runeFill1, 8)+'</g>'
      + '<g transform="translate(43,25) scale(0.64)" opacity="'+runeOp2+'">'+runeMarkup(rune.n, "#5c676e", 8)+'</g>'
      + '</svg></div>';

    return back + front;
  }

  /* ====== CONSTRUCTION DU TAS ====== */
  function buildPile(){
    var mat = $("rntMat");
    if(!mat) return;
    mat.innerHTML = "";
    fanRunes = shuffle(RUNES).slice(0, POOL_COUNT);
    picked = []; busy = false;

    var cx = 50, cy = 50;
    var n = POOL_COUNT;
    for(var i=0;i<n;i++){
      var el = document.createElement("div");
      el.className = "rnt-pebble";
      el.setAttribute("data-i", i);
      el.setAttribute("role","button");
      el.setAttribute("tabindex","0");
      el.setAttribute("aria-label","Piocher une pierre runique");
      el.innerHTML = stoneSVG(fanRunes[i], {reveal:false});

      var ang = (i / n) * Math.PI * 2 + rand(-0.4, 0.4);
      var radius = rand(6, 30);
      var px = cx + Math.cos(ang) * radius + rand(-3,3);
      var py = cy + Math.sin(ang) * radius * 0.72 + rand(-3,3);
      var rot = rand(-38, 38);
      el.style.left = px + "%";
      el.style.top  = py + "%";
      el.style.setProperty("transform", "rotate("+rot+"deg)", "important");
      el.setAttribute("data-rot", rot);
      el.style.zIndex = (10 + i);

      mat.appendChild(el);
      (function(node, idx){ setTimeout(function(){ node.classList.add("rnt-in"); }, 55*idx + 100); })(el, i);
    }
  }

  function updateProgress(){
    var instr = $("rntInstruction"); var prog = $("rntProgress");
    var remaining = PICK_COUNT - picked.length;
    if(prog){ prog.textContent = picked.length + " / " + PICK_COUNT + " pierres pioch\u00e9es"; }
    if(instr){
      if(remaining === PICK_COUNT){ instr.textContent = "Concentre-toi, puis pioche ta premi\u00e8re pierre."; }
      else if(remaining === 2){ instr.textContent = "Bien. Pioche ta deuxi\u00e8me pierre."; }
      else if(remaining === 1){ instr.textContent = "Encore une : pioche ta troisi\u00e8me pierre."; }
      else{ instr.textContent = "Les runes ont parl\u00e9."; }
    }
  }

  /* ====== BURST DE PARTICULES (dorees + argentees) ====== */
  function spawnParticles(el){
    var burst = document.createElement("div");
    burst.className = "rnt-burst";
    el.appendChild(burst);
    var count = 22;
    for(var i=0;i<count;i++){
      var p = document.createElement("span");
      var gold = (i % 2 === 0);
      p.className = "rnt-particle " + (gold ? "rnt-gold" : "rnt-silver");
      var size = rand(4, 9);
      p.style.width  = size + "px";
      p.style.height = size + "px";
      var ang = (i / count) * Math.PI * 2 + rand(-0.3, 0.3);
      var dist = rand(38, 78);
      var dx = Math.cos(ang) * dist;
      var dy = Math.sin(ang) * dist - rand(6, 26);
      p.style.setProperty("--rnt-dx", dx.toFixed(1) + "px");
      p.style.setProperty("--rnt-dy", dy.toFixed(1) + "px");
      p.style.setProperty("--rnt-sc", rand(0.3, 0.9).toFixed(2));
      p.style.marginLeft = (-size/2) + "px";
      p.style.marginTop  = (-size/2) + "px";
      burst.appendChild(p);
      (function(node, delay){
        setTimeout(function(){ node.classList.add("rnt-go"); }, delay);
      })(p, Math.floor(rand(0, 240)));
    }
    setTimeout(function(){ if(burst && burst.parentNode){ burst.parentNode.removeChild(burst); } }, 2600);
  }

  function onPick(el){
    if(busy) return;
    var i = parseInt(el.getAttribute("data-i"),10);
    if(picked.indexOf(i) !== -1 || picked.length >= PICK_COUNT) return;
    picked.push(i);
    SFX.pick(picked.length);

    var rune = fanRunes[i];
    var golden = stoneSVG(rune, {reveal:true});
    var tmp = document.createElement("div");
    tmp.innerHTML = golden;
    var newFront = tmp.querySelector(".rnt-front");
    var oldFront = el.querySelector(".rnt-front");
    if(newFront && oldFront){ oldFront.parentNode.replaceChild(newFront, oldFront); }

    el.classList.add("rnt-picked","rnt-flip","rnt-shine");
    var rot = parseFloat(el.getAttribute("data-rot")) || 0;
    el.style.setProperty("transform", "rotate("+(rot*0.2)+"deg) translateY(-14px) scale(1.15)", "important");
    el.style.zIndex = 70;

    setTimeout(function(){ spawnParticles(el); }, 260);

    updateProgress();
    if(picked.length >= PICK_COUNT){
      busy = true;
      SFX.gather();
      var all = $("rntMat").querySelectorAll(".rnt-pebble");
      for(var k=0;k<all.length;k++){ if(!all[k].classList.contains("rnt-picked")){ all[k].classList.add("rnt-dim"); } }
      setTimeout(revealResult, 1600);
    }
  }

  /* ====== PARTICULES DISCRETES autour d'une rune de resultat ====== */
  function spawnSlotParticles(host){
    var burst = document.createElement("div");
    burst.className = "rnt-burst";
    host.appendChild(burst);
    var count = 10;
    for(var i=0;i<count;i++){
      var p = document.createElement("span");
      var gold = (i % 2 === 0);
      p.className = "rnt-particle rnt-soft " + (gold ? "rnt-gold" : "rnt-silver");
      var size = rand(3, 6);
      p.style.width  = size + "px";
      p.style.height = size + "px";
      var ang = (i / count) * Math.PI * 2 + rand(-0.4, 0.4);
      var dist = rand(22, 44);
      var dx = Math.cos(ang) * dist;
      var dy = Math.sin(ang) * dist - rand(2, 12);
      p.style.setProperty("--rnt-dx", dx.toFixed(1) + "px");
      p.style.setProperty("--rnt-dy", dy.toFixed(1) + "px");
      p.style.setProperty("--rnt-sc", rand(0.2, 0.6).toFixed(2));
      p.style.marginLeft = (-size/2) + "px";
      p.style.marginTop  = (-size/2) + "px";
      burst.appendChild(p);
      (function(node, delay){ setTimeout(function(){ node.classList.add("rnt-go"); }, delay); })(p, Math.floor(rand(0, 400)));
    }
  }

  /* ====== INTERPRETATION COMPLETE (n8n, inscrits via cette page) ====== */
  var drawId = 0, sending = false, pendingDraw = false;
  function drawIds(){ var ids = []; for(var i=0;i<lastChosen.length;i++){ ids.push(RUNES.indexOf(lastChosen[i])); } return ids; }
  function questionHtml(){
    var q = ($("rntQuestion") && $("rntQuestion").value) ? ($("rntQuestion").value||"").trim().slice(0,160) : "";
    return q ? '<p class="rnt-read-intro">Ta question : <em>&laquo; '+escapeHtml(q)+' &raquo;</em></p>' : "";
  }
  function renderReading(paras){
    var box = $("rntReadingTxt"); if(!box) return;
    var h = questionHtml();
    for(var i=0;i<paras.length;i++){
      h += "<p>" + escapeHtml(paras[i]).replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
        .replace("[[bracelets]]", '<a href="https://www.astroya.fr/collections/bracelets-pierre">D\u00e9couvre nos bracelets en pierres naturelles</a>') + "</p>";
    }
    box.innerHTML = h;
  }
  function lockedReading(){
    var box = $("rntReadingTxt"); if(!box) return;
    box.innerHTML = questionHtml()
      + '<p class="rnt-lock-p">\uD83D\uDD12 Comment tes trois runes se r\u00e9pondent, du pass\u00e9 au futur, la lecture d\u2019ensemble et ton conseil runique.</p>'
      + '<button type="button" class="rnt-lock-btn" id="rntDeepBtn">\u2726 Lire mon interpr\u00e9tation compl\u00e8te</button>'
      + '<p class="rnt-lock-note">Gratuite, il suffit de ton adresse e-mail.</p>';
  }
  /* inscrit via cette page : l'interpretation s'affiche d'elle-meme, sans popup */
  function loadDeep(){
    var auth = getAuth(); if(!auth.email) return;
    var my = drawId;
    ask({ action:"reveal", ids: drawIds(), email: auth.email, token: auth.token }).then(function(d){
      if(my !== drawId) return;
      saveAuth(auth.email, d.token || auth.token);
      renderReading(d.reading);
    }, function(){ /* pas (encore) inscrit via cette page : reste verrouillee, rien n'est efface */ });
  }

  function lc(s){ return s ? s.charAt(0).toLowerCase()+s.slice(1) : s; }
  function escapeHtml(s){ return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }

  function revealResult(){
    var slots = $("rntSlots");
    var chosen = picked.map(function(i){ return fanRunes[i]; });
    lastChosen = chosen.slice();
    var html = "";
    for(var i=0;i<chosen.length;i++){
      var r = chosen[i];
      html += '<div class="rnt-slot rnt-slot-await" data-ci="'+i+'" style="animation-delay:'+(i*0.15)+'s">'
            +   '<div class="rnt-slot-pos">'+POSITIONS[i]+'</div>'
            +   '<div class="rnt-slot-hint">Cliquer sur la carte</div>'
            +   '<div class="rnt-slot-glyphwrap">'+runeImg(r, "rnt-card-slot")+'</div>'
            +   '<div class="rnt-slot-name">'+r.n+'</div>'
            +   '<div class="rnt-slot-kw">'+r.kw+'</div>'
            +   '<div class="rnt-slot-txt">'+r.txt+'</div>'
            +   '<div class="rnt-slot-stone-al"><span class="rnt-slot-stone-lbl">Pierre align\u00e9e</span>'+r.stone+'</div>'
            +   '<a class="rnt-rlink" href="'+runePageUrl(r.n)+'">Tout savoir sur '+r.n+' \u2192</a>'
            + '</div>';
    }
    slots.innerHTML = html; slots.classList.add("rnt-show");

    flyCardsIn(chosen);

    var wraps = slots.querySelectorAll(".rnt-slot-glyphwrap");
    for(var w=0; w<wraps.length; w++){
      (function(host, idx){
        setTimeout(function(){ spawnSlotParticles(host); }, 900 + idx*220);
        var loop = setInterval(function(){
          if(!slots.classList.contains("rnt-show")){ clearInterval(loop); return; }
          spawnSlotParticles(host);
        }, 2600);
        slots.setAttribute("data-loop"+idx, "1");
      })(wraps[w], w);
    }

    var reading = $("rntReading");
    if(reading){
      drawId++;
      lockedReading();
      reading.classList.add("rnt-show");
      loadDeep();
    }
    var rep = $("rntReplay"); if(rep){ rep.classList.add("rnt-show-btn"); }
    setDraws(getDraws() + 1);
    updateCounter();
    try{ slots.scrollIntoView({behavior:"smooth", block:"center"}); }catch(e){}
  }

  /* ====== [WOW] VOL DES CARTES DEPUIS LE TAS ====== */
  function flyCardsIn(chosen){
    var slots = $("rntSlots");
    var mat = $("rntMat");
    if(!slots) return;
    var pickedPebbles = mat ? mat.querySelectorAll(".rnt-pebble.rnt-picked") : [];
    var awaiting = slots.querySelectorAll(".rnt-slot-await");

    for(var i=0;i<awaiting.length;i++){
      (function(slot, idx){
        var target = slot.querySelector(".rnt-slot-glyphwrap");
        if(!target){ slot.classList.remove("rnt-slot-await"); return; }
        var tRect = target.getBoundingClientRect();
        var srcRect = null;
        if(pickedPebbles[idx]){ srcRect = pickedPebbles[idx].getBoundingClientRect(); }
        else if(mat){ srcRect = mat.getBoundingClientRect(); }
        if(!tRect || !srcRect){ slot.classList.remove("rnt-slot-await"); return; }

        var flyer = document.createElement("div");
        flyer.className = "rnt-flyer";
        flyer.innerHTML = runeImg(chosen[idx], "rnt-card-fly");
        document.body.appendChild(flyer);

        var startX = srcRect.left + srcRect.width/2;
        var startY = srcRect.top + srcRect.height/2;
        var endX   = tRect.left + tRect.width/2;
        var endY   = tRect.top + tRect.height/2;

        flyer.style.setProperty("width", tRect.width + "px", "important");
        flyer.style.setProperty("height", tRect.height + "px", "important");
        flyer.style.setProperty("left", (startX) + "px", "important");
        flyer.style.setProperty("top", (startY) + "px", "important");
        flyer.style.setProperty("transform", "translate(-50%,-50%) translate(0px,0px) rotateY(0deg) scale(.18)", "important");
        flyer.style.setProperty("opacity", "0", "important");

        var dx = endX - startX;
        var dy = endY - startY;
        var delay = 140 + idx*230;

        setTimeout(function(){
          flyer.classList.add("rnt-flyer-go");
          SFX.whoosh();
          flyer.style.setProperty("opacity", "1", "important");
          flyer.style.setProperty("transform",
            "translate(-50%,-50%) translate("+dx.toFixed(0)+"px,"+dy.toFixed(0)+"px) rotateY(540deg) scale(1)", "important");
        }, delay);

        setTimeout(function(){
          slot.classList.remove("rnt-slot-await");
          slot.classList.add("rnt-slot-land");
          SFX.land(idx);
          spawnParticles(target);
          if(flyer && flyer.parentNode){ flyer.parentNode.removeChild(flyer); }
          setTimeout(function(){ slot.classList.remove("rnt-slot-land"); }, 900);
        }, delay + 900);
      })(awaiting[i], i);
    }
  }

  /* ====== [CAROUSEL INLINE] ====== */
  function carEls(which){
    var base = which.host;
    return {
      wrap: $(base),
      track: $(base+"Track"),
      dots: $(base+"Dots"),
      counter: $(base+"Counter")
    };
  }

  function renderCarousel(which){
    var e = carEls(which);
    if(!e.wrap || !e.track) return;
    var r = which.arr[which.idx];
    if(!r) return;
    e.track.innerHTML =
        '<a class="rnt-car-card" href="'+runePageUrl(r.n)+'" aria-label="Signification de la rune '+r.n+'">'+runeImg(r, "rnt-card-car rnt-card-on")+'</a>'
      + '<div class="rnt-car-body">'
      +   '<div class="rnt-car-name">'+r.n+'</div>'
      +   '<div class="rnt-car-kw">'+r.kw+'</div>'
      +   '<p class="rnt-car-mean">'+r.mean+'</p>'
      +   '<p class="rnt-car-line"><strong>Domaine :</strong> '+r.dom+'</p>'
      +   '<p class="rnt-car-line"><strong>Conseil :</strong> '+r.adv+'</p>'
      +   '<p class="rnt-car-line"><strong>Pierre align\u00e9e :</strong> '+r.stone+'</p>'
      +   '<a class="rnt-rlink rnt-rlink-car" href="'+runePageUrl(r.n)+'">Lire la signification compl\u00e8te de '+r.n+' \u2192</a>'
      + '</div>';
    e.track.classList.remove("rnt-car-anim");
    void e.track.offsetWidth;
    e.track.classList.add("rnt-car-anim");
    if(e.dots){
      var d = "";
      for(var i=0;i<which.arr.length;i++){
        d += '<button class="rnt-car-dot'+(i===which.idx?' rnt-on':'')+'" data-dot="'+i+'" aria-label="Rune '+(i+1)+'"></button>';
      }
      e.dots.innerHTML = d;
    }
    if(e.counter){ e.counter.textContent = (which.idx+1) + " / " + which.arr.length; }
  }

  function openCarousel(which, arr, idx){
    which.arr = arr; which.idx = idx || 0;
    var e = carEls(which);
    if(!e.wrap) return;
    renderCarousel(which);
    e.wrap.classList.add("rnt-car-open");
    try{ e.wrap.scrollIntoView({behavior:"smooth", block:"center"}); }catch(err){}
  }
  function closeCarousel(which){
    var e = carEls(which);
    if(e.wrap){ e.wrap.classList.remove("rnt-car-open"); }
  }
  function carGo(which, dir){
    if(!which.arr.length) return;
    which.idx = (which.idx + dir + which.arr.length) % which.arr.length;
    SFX.slide(which.idx, dir);
    renderCarousel(which);
  }
  function carJump(which, i){
    if(i<0 || i>=which.arr.length) return;
    SFX.slide(i, i > which.idx ? 1 : -1);
    which.idx = i; renderCarousel(which);
  }

  /* swipe tactile sur les deux carousels */
  function bindSwipe(which){
    var e = carEls(which);
    if(!e.wrap || e.wrap.getAttribute("data-swipe")==="1") return;
    var x0=null;
    e.wrap.addEventListener("touchstart", function(ev){ x0 = ev.touches[0].clientX; }, {passive:true});
    e.wrap.addEventListener("touchend", function(ev){
      if(x0===null) return;
      var dx = ev.changedTouches[0].clientX - x0;
      if(Math.abs(dx) > 40){ carGo(which, dx<0 ? 1 : -1); }
      x0=null;
    }, {passive:true});
    e.wrap.setAttribute("data-swipe","1");
  }

  /* relance un tirage complet (consomme un tirage) + remonte vers le tapis */
  function newDraw(){
    var done = getDraws();
    if(done >= MAX_DRAWS){ updateCounter(); return; }
    if(done >= GATE_AFTER && !getEmail()){ openModal(); return; }
    drawId++;
    var slots=$("rntSlots"); if(slots){ slots.classList.remove("rnt-show"); slots.innerHTML="\u200b"; }
    var reading=$("rntReading"); if(reading){ reading.classList.remove("rnt-show"); }
    var rep=$("rntReplay"); if(rep){ rep.classList.remove("rnt-show-btn"); }
    closeCarousel(carDraw);
    buildPile(); updateProgress(); updateCounter();
    try{
      var eng = $("rntMat");
      if(eng){ eng.scrollIntoView({behavior:"smooth", block:"center"}); }
    }catch(e){}
  }

  /* recommence le tas en cours SANS consommer de tirage (tant que non revele) */
  function resetPile(){
    var done = getDraws();
    if(done >= MAX_DRAWS){ updateCounter(); return; }
    if(done >= GATE_AFTER && !getEmail()){ openModal(); return; }
    var slots=$("rntSlots"); if(slots){ slots.classList.remove("rnt-show"); slots.innerHTML="\u200b"; }
    var reading=$("rntReading"); if(reading){ reading.classList.remove("rnt-show"); }
    var rep=$("rntReplay"); if(rep){ rep.classList.remove("rnt-show-btn"); }
    closeCarousel(carDraw);
    buildPile(); updateProgress();
    try{ var m=$("rntMat"); if(m){ m.scrollIntoView({behavior:"smooth", block:"center"}); } }catch(e){}
  }

  function updateCounter(){
    var c = $("rntCounter"); if(!c) return;
    var left = MAX_DRAWS - getDraws();
    if(left>0){ c.textContent = left + " tirage" + (left>1?"s":"") + " restant" + (left>1?"s":"") + " aujourd'hui"; }
    else{ c.textContent = "Tu as atteint tes 5 tirages du jour. Reviens demain \u2728"; var rep=$("rntReplay"); if(rep){ rep.classList.remove("rnt-show-btn"); } }
  }

  /* ====== POPUP EMAIL : 2 ECRANS SUCCESSIFS ====== */
  function popStep(n){ var f=$("rnmStepForm"), sc=$("rnmStepSuccess"); if(f){ f.hidden=(n!==1); } if(sc){ sc.hidden=(n!==2); } }
  function popError(msg){
    var e=$("rnmError"); if(!e) return;
    if(!msg){ e.classList.remove("rnm-show"); e.innerHTML="&#8203;"; return; }
    e.textContent=msg; e.classList.add("rnm-show");
  }
  /* ouverte par le bouton de l'interpretation, ou au 3e tirage sans inscription (regle d'origine) */
  function openModal(fromGate){
    var m=$("rnmModal"); if(!m) return;
    pendingDraw = (fromGate !== false);
    popStep(1); popError("");
    var em=$("rnmEmail"); if(em && !em.value){ em.value = knownEmail(); }
    m.classList.add("rnm-open"); m.setAttribute("aria-hidden","false"); SFX.portal();
    document.body.classList.add("rnm-lock");
    if(window.innerWidth > 700){ setTimeout(function(){ var i=$("rnmEmail"); if(i){ i.focus(); } }, 200); }
  }
  function closeModal(){
    var m=$("rnmModal"); if(!m) return;
    m.classList.remove("rnm-open"); m.setAttribute("aria-hidden","true");
    document.body.classList.remove("rnm-lock");
  }
  function submitEmail(){
    if(sending) return;
    var emEl=$("rnmEmail"), cb=$("rnmConsent"), btn=$("rnmSubmit");
    var em = emEl ? (emEl.value||"").trim().toLowerCase() : "";
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)){ popError("Indique une adresse e-mail valide."); if(emEl){ emEl.focus(); } return; }
    if(!cb || !cb.checked){
      popError("Coche la case pour recevoir ton interpr\u00e9tation compl\u00e8te.");
      var lab=document.querySelector("#rnmModal .rnm-consent");
      if(lab){ lab.classList.add("rnm-invalid"); setTimeout(function(){ lab.classList.remove("rnm-invalid"); }, 600); }
      return;
    }
    popError(""); sending = true;
    if(btn){ btn.disabled=true; btn.textContent="Envoi\u2026"; }
    function restore(){ sending=false; if(btn){ btn.disabled=false; btn.textContent="Recevoir mon interpr\u00e9tation"; } }
    var my = drawId, ids = (lastChosen.length===3 && $("rntSlots") && $("rntSlots").classList.contains("rnt-show")) ? drawIds() : null;
    /* un seul appel : n8n inscrit aux listes Tirage de runes + newsletter et renvoie l'interpretation */
    ask({ action:"subscribe", email: em, consent: true, ids: ids }).then(function(d){
      saveAuth(em, d.token);
      if(d.reading && my === drawId){ renderReading(d.reading); }
      popStep(2); restore(); SFX.success();
    }, function(err){
      var c = err && err.code;
      popError(c==="email" ? "Cette adresse e-mail semble incorrecte. V\u00e9rifie-la et r\u00e9essaie."
        : c==="klaviyo" ? "L\u2019inscription n\u2019a pas pu aboutir. R\u00e9essaie dans un instant."
        : "Connexion interrompue. V\u00e9rifie ton r\u00e9seau et r\u00e9essaie.");
      restore();
    });
  }
  function afterSuccess(){
    closeModal();
    if(pendingDraw){ pendingDraw=false; newDraw(); return; }
    try{ var r=$("rntReading"); if(r){ r.scrollIntoView({behavior:"smooth", block:"start"}); } }catch(e){}
  }

  /* ============================================================= */
  /* DECOR SAISONNIER (change selon la date reelle)                */
  /* ============================================================= */
  function currentSeason(){
    var m = new Date().getMonth() + 1;
    if(m>=3 && m<=5) return "printemps";
    if(m>=6 && m<=8) return "ete";
    if(m>=9 && m<=11) return "automne";
    return "hiver";
  }
  function buildSeasonDecor(){
    var wrap = document.querySelector(".rnt-wrap");
    if(!wrap || wrap.getAttribute("data-season")) return;
    var s = currentSeason();
    wrap.setAttribute("data-season", s);
    wrap.classList.add("rnt-season-"+s);
    var deco = document.createElement("div");
    deco.className = "rnt-ambient rnt-amb-"+s;
    var count = (s==="hiver") ? 34 : (s==="automne" ? 22 : (s==="printemps" ? 22 : 20));
    var html = "";
    for(var i=0;i<count;i++){
      var left = rand(0,100).toFixed(1);
      var dur  = rand(6,15).toFixed(1);
      var del  = rand(0,10).toFixed(1);
      var sc   = rand(0.5,1.3).toFixed(2);
      var drift= rand(-60,60).toFixed(0);
      html += '<span class="rnt-amb-bit" style="left:'+left+'%; --rnt-adur:'+dur+'s; --rnt-adel:'+del+'s; --rnt-asc:'+sc+'; --rnt-adrift:'+drift+'px;"></span>';
    }
    deco.innerHTML = html;
    var hero = document.querySelector(".rnt-hero-zone");
    if(hero){ hero.appendChild(deco); }
  }

  /* ====== DELEGATION ====== */
  document.addEventListener("click", function(ev){
    var t = ev.target; if(!t || !t.closest) return;
    /* [LIENS] liens vers les pages runes : navigation normale */
    if(t.closest("a.rnt-rlink, a.rnt-car-card, a.rnt-band-link, a.tdr-rlink")){ return; }
    var peb = t.closest(".rnt-pebble");
    if(peb && $("rntMat") && $("rntMat").contains(peb)){ ev.preventDefault(); onPick(peb); return; }
    if(t.closest("#rntDeepBtn")){ ev.preventDefault(); openModal(false); return; }
    if(t.closest("#rnmClose") || t.closest("#rnmOverlay")){ ev.preventDefault(); pendingDraw=false; closeModal(); return; }
    if(t.closest("#rnmSubmit")){ ev.preventDefault(); submitEmail(); return; }
    if(t.closest("#rnmContinue")){ ev.preventDefault(); afterSuccess(); return; }

    var slot = t.closest(".rnt-slot");
    if(slot && $("rntSlots") && $("rntSlots").contains(slot)){
      ev.preventDefault();
      var ci = parseInt(slot.getAttribute("data-ci"),10) || 0;
      bindSwipe(carDraw);
      SFX.open();
      openCarousel(carDraw, lastChosen.slice(), ci);
      return;
    }

    if(t.closest("#rntDrawCarouselPrev")){ ev.preventDefault(); carGo(carDraw,-1); return; }
    if(t.closest("#rntDrawCarouselNext")){ ev.preventDefault(); carGo(carDraw, 1); return; }
    if(t.closest("#rntDrawCarouselClose")){ ev.preventDefault(); SFX.close(); closeCarousel(carDraw); return; }
    var dd = t.closest("#rntDrawCarouselDots .rnt-car-dot");
    if(dd){ ev.preventDefault(); carJump(carDraw, parseInt(dd.getAttribute("data-dot"),10)); return; }

    if(t.closest("#rntReplay")){ ev.preventDefault(); SFX.renew(); newDraw(); return; }
    if(t.closest("#rntReset")){ ev.preventDefault(); SFX.renew(); resetPile(); return; }
  }, false);
  /* [SON] survol des cartes (souris) */
  document.addEventListener("mouseover", function(ev){
    var t = ev.target; if(!t || !t.closest) return;
    var card = t.closest("#rntSlots .rnt-slot-glyphwrap, #rntDrawCarouselTrack .rnt-car-card, #rntMat .rnt-pebble");
    if(!card) return;
    var from = ev.relatedTarget;
    if(from && card.contains && card.contains(from)) return;
    SFX.hover();
  }, false);
  document.addEventListener("keydown", function(ev){
    var t = ev.target; if(!t) return;
    var pm=$("rnmModal");
    if(pm && pm.classList.contains("rnm-open")){
      if(ev.key==="Escape"){ pendingDraw=false; closeModal(); }
      else if(t.id==="rnmEmail" && ev.key==="Enter"){ ev.preventDefault(); submitEmail(); }
      return;
    }
    if(t.classList && t.classList.contains("rnt-pebble") && (ev.key==="Enter"||ev.key===" ")){ ev.preventDefault(); onPick(t); return; }
    if(ev.key==="ArrowLeft" || ev.key==="ArrowRight"){
      var dir = ev.key==="ArrowRight" ? 1 : -1;
      if($("rntDrawCarousel") && $("rntDrawCarousel").classList.contains("rnt-car-open")){ carGo(carDraw, dir); }
    }
  }, false);

  /* bandeau decoratif : 24 runes en petits SVG (aucune police requise) */
  function buildRuneband(){
    var band = $("rntRuneband");
    if(!band || band.getAttribute("data-built")==="1") return;
    var html = "";
    for(var i=0;i<RUNES.length;i++){
      html += '<a class="rnt-band-link" href="'+runePageUrl(RUNES[i].n)+'" title="Rune '+RUNES[i].n+'" aria-label="Signification de la rune '+RUNES[i].n+'">'
            + '<svg class="rnt-band-rune" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'+runeMarkup(RUNES[i].n, "#e7d4ac", 8)+'</svg></a>';
    }
    band.innerHTML = html;
    band.setAttribute("data-built","1");
  }

  /* ====== [AURORE] CIEL ETOILE + ETOILES FILANTES ====== */
  var shootTimer = null;
  function buildSky(){
    var stars = $("rntStars");
    if(!stars || stars.getAttribute("data-built")==="1") return;
    var count = 90;
    var html = "";
    for(var i=0;i<count;i++){
      var sz = rand(1, 2.6).toFixed(1);
      var x = rand(0,100).toFixed(2);
      var y = rand(0,88).toFixed(2);
      var tw = rand(1.8, 5).toFixed(1);
      var td = rand(0, 5).toFixed(1);
      var op = rand(0.4, 1).toFixed(2);
      html += '<span class="rnt-star" style="width:'+sz+'px;height:'+sz+'px;left:'+x+'%;top:'+y+'%;'
            + '--rnt-tw:'+tw+'s;--rnt-td:'+td+'s;opacity:'+op+'"></span>';
    }
    stars.innerHTML = html;
    stars.setAttribute("data-built","1");

    if(shootTimer){ return; }
    function launchShoot(){
      var sky = $("rntSky");
      if(sky){
        var s = document.createElement("span");
        s.className = "rnt-shooting";
        var startX = rand(30, 95);
        var startY = rand(4, 34);
        s.style.left = startX + "%";
        s.style.top  = startY + "%";
        s.style.setProperty("--rnt-sx", (-rand(220,420)).toFixed(0)+"px");
        s.style.setProperty("--rnt-sy", (rand(120,240)).toFixed(0)+"px");
        s.style.setProperty("--rnt-sr", rand(18,30).toFixed(0)+"deg");
        sky.appendChild(s);
        setTimeout(function(){ s.classList.add("rnt-shoot-go"); }, 20);
        setTimeout(function(){ if(s.parentNode){ s.parentNode.removeChild(s); } }, 1200);
      }
      shootTimer = setTimeout(launchShoot, rand(4000, 9000));
    }
    shootTimer = setTimeout(launchShoot, rand(2000, 4000));
  }

  /* ====== [SON] AMBIANCE SONORE COSMIQUE + VIBRATIONS (Web Audio, aucun fichier externe) ======
     Sons doux : flute, cristal, nappes d'aurore, echo spatial. Vibrations legeres sur mobile (Android).
     Bouton on/off memorise (coupe les sons ET les vibrations). */
  var LS_SOUND = "astroya_rnt_sound";
  var SFX = (function(){
    var ctx = null, master = null, noiseBuf = null, spc = null, lastHover = 0;
    var on = true;
    try{ on = localStorage.getItem(LS_SOUND) !== "0"; }catch(e){}
    function vib(p){ if(!on) return; try{ if(navigator.vibrate){ navigator.vibrate(p); } }catch(e){} }
    function ac(){
      if(!on) return null;
      if(!ctx){
        var C = window.AudioContext || window.webkitAudioContext;
        if(!C) return null;
        try{ ctx = new C(); }catch(e){ return null; }
        master = ctx.createGain(); master.gain.value = 0.5;
        var comp = ctx.createDynamicsCompressor(); master.connect(comp); comp.connect(ctx.destination);
        var len = Math.floor(ctx.sampleRate * 1.5);
        noiseBuf = ctx.createBuffer(1, len, ctx.sampleRate);
        var d = noiseBuf.getChannelData(0);
        for(var i=0;i<len;i++){ d[i] = Math.random()*2-1; }
      }
      if(ctx.state === "suspended"){ try{ ctx.resume(); }catch(e){} }
      return ctx;
    }
    /* echo cosmique : deux delais filtres en boucle */
    function space(){
      if(spc) return spc;
      var inp = ctx.createGain(), d1 = ctx.createDelay(1.5), d2 = ctx.createDelay(1.5), fb = ctx.createGain(), lp = ctx.createBiquadFilter(), out = ctx.createGain();
      d1.delayTime.value = 0.31; d2.delayTime.value = 0.47; fb.gain.value = 0.4; lp.type = "lowpass"; lp.frequency.value = 2600; out.gain.value = 0.6;
      inp.connect(d1); inp.connect(d2); d1.connect(lp); d2.connect(lp); lp.connect(fb); fb.connect(d1); lp.connect(out); out.connect(master);
      spc = inp; return spc;
    }
    function env(g, t, a, peak, dec){
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(peak, t + a);
      g.gain.exponentialRampToValueAtTime(0.0001, t + a + dec);
    }
    function out(g, wet){ g.connect(master); if(wet){ g.connect(space()); } }
    function tone(f, t, dur, type, vol, att, wet){
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = type || "sine"; o.frequency.setValueAtTime(f, t);
      env(g, t, att || 0.005, vol, dur);
      o.connect(g); out(g, wet); o.start(t); o.stop(t + (att||0.005) + dur + 0.05);
    }
    function air(t, dur, f1, f2, q, vol, att){
      var s = ctx.createBufferSource(), bp = ctx.createBiquadFilter(), g = ctx.createGain();
      s.buffer = noiseBuf; bp.type = "bandpass"; bp.Q.value = q || 1;
      bp.frequency.setValueAtTime(f1, t);
      if(f2){ bp.frequency.exponentialRampToValueAtTime(f2, t + dur); }
      env(g, t, att || 0.01, vol, dur);
      s.connect(bp); bp.connect(g); out(g, true); s.start(t); s.stop(t + (att||0.01) + dur + 0.05);
    }
    function crystal(f, t, vol, dec){
      tone(f, t, dec, "sine", vol, 0.006, true);
      tone(f*2.76, t, dec*0.4, "sine", vol*0.22, 0.004, true);
      tone(f*5.40, t, dec*0.18, "sine", vol*0.08, 0.003, false);
    }
    /* note de flute : sinus + vibrato lent + souffle */
    function flute(f, t, dur, vol){
      var o = ctx.createOscillator(), lfo = ctx.createOscillator(), ld = ctx.createGain(), g = ctx.createGain(), lp = ctx.createBiquadFilter();
      o.type = "sine"; o.frequency.value = f; lfo.frequency.value = 4.8; ld.gain.value = f*0.006;
      lfo.connect(ld); ld.connect(o.frequency); lp.type = "lowpass"; lp.frequency.value = 2600;
      o.connect(lp); lp.connect(g);
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol, t + 0.12); g.gain.setTargetAtTime(0.0001, t + dur, 0.3);
      out(g, true); o.start(t); lfo.start(t); o.stop(t + dur + 1.6); lfo.stop(t + dur + 1.6);
      air(t, Math.min(0.5, dur), f*2, 0, 7, vol*0.16, 0.06);
    }
    /* nappe d'aurore boreale */
    function aurora(t, dur, vol){
      var f = [146.83, 220.00, 293.66, 369.99], k;
      for(k=0;k<f.length;k++){
        var o = ctx.createOscillator(), lp = ctx.createBiquadFilter(), g = ctx.createGain();
        o.type = k < 2 ? "triangle" : "sine"; o.frequency.value = f[k]; o.detune.value = (k%2 ? 7 : -7);
        lp.type = "lowpass"; lp.frequency.setValueAtTime(380, t); lp.frequency.linearRampToValueAtTime(1500, t + dur*0.6); lp.frequency.linearRampToValueAtTime(500, t + dur + 1);
        o.connect(lp); lp.connect(g); out(g, true);
        g.gain.setValueAtTime(0.0001, t); g.gain.linearRampToValueAtTime(vol - k*vol*0.15, t + dur*0.45); g.gain.setTargetAtTime(0.0001, t + dur*0.6, dur*0.3);
        o.start(t); o.stop(t + dur + 3);
      }
      air(t + 0.1, dur + 0.6, 2800, 5200, 4, vol*0.45, dur*0.3);
    }
    var PENTA = [523.25, 587.33, 659.25, 783.99, 880.00, 1046.5];
    return {
      isOn: function(){ return on; },
      setOn: function(v){ on = !!v; try{ localStorage.setItem(LS_SOUND, on ? "1" : "0"); }catch(e){} if(on){ ac(); } },
      /* galet pioche : effleurement de pierre + note de flute qui monte */
      pick: function(n){
        vib(12);
        if(!ac()) return; var t = ctx.currentTime;
        tone(170, t, 0.12, "sine", 0.16, 0.004, false);
        air(t, 0.08, 1800, 900, 2, 0.08, 0.004);
        flute([392.00, 493.88, 587.33][Math.max(0, Math.min(2, n-1))], t + 0.04, 0.7, 0.085);
      },
      /* 3e pierre : l'aurore se leve */
      gather: function(){
        vib([8, 70, 8]);
        if(!ac()) return; aurora(ctx.currentTime + 0.1, 1.8, 0.03);
      },
      /* une carte s'envole */
      whoosh: function(){
        vib(6);
        if(!ac()) return; air(ctx.currentTime, 0.6, 500, 3000, 1.1, 0.12, 0.15);
      },
      /* une carte se pose : cristal (re - la - re) */
      land: function(idx){
        vib(idx === 2 ? [18, 50, 28] : 14);
        if(!ac()) return; var t = ctx.currentTime;
        crystal([587.33, 880.00, 1174.66][idx % 3], t, 0.16, 2.2);
        if(idx === 2){ aurora(t + 0.1, 2.4, 0.022); }
      },
      /* survol d'une carte (souris) : poussiere d'etoile */
      hover: function(){
        if(!ac()) return; var now = Date.now(); if(now - lastHover < 160) return; lastHover = now;
        var t = ctx.currentTime;
        tone(2349.3, t, 0.3, "sine", 0.028, 0.006, true);
        tone(3135.9, t + 0.06, 0.32, "sine", 0.018, 0.006, true);
      },
      /* clic sur une carte : arpege de harpe celeste */
      open: function(){
        vib(10);
        if(!ac()) return; var t = ctx.currentTime;
        var n = [523.25, 659.25, 783.99, 1046.5];
        for(var i=0;i<n.length;i++){ crystal(n[i], t + i*0.07, 0.07, 0.9); }
      },
      /* passage d'une carte a l'autre dans le slider */
      slide: function(idx, dir){
        vib(8);
        if(!ac()) return; var t = ctx.currentTime;
        air(t, 0.28, dir > 0 ? 900 : 2600, dir > 0 ? 2600 : 900, 1.3, 0.07, 0.04);
        flute(PENTA[(idx || 0) % PENTA.length], t + 0.04, 0.35, 0.06);
      },
      close: function(){
        vib(6);
        if(!ac()) return; var t = ctx.currentTime;
        crystal(783.99, t, 0.06, 0.6); crystal(523.25, t + 0.09, 0.05, 0.8);
      },
      /* nouveau tirage / recommencer : souffle qui remonte */
      renew: function(){
        vib(10);
        if(!ac()) return; var t = ctx.currentTime;
        air(t, 0.7, 300, 2400, 0.9, 0.08, 0.35); crystal(659.25, t + 0.45, 0.06, 1.2);
      },
      /* ouverture de la fenetre interpretation */
      portal: function(){
        vib(8);
        if(!ac()) return; aurora(ctx.currentTime, 1.3, 0.02);
      },
      /* interpretation debloquee */
      success: function(){
        vib([20, 40, 20, 40, 60]);
        if(!ac()) return; var t = ctx.currentTime, n = [587.33, 739.99, 880.00, 1174.66];
        for(var i=0;i<n.length;i++){ crystal(n[i], t + i*0.11, 0.09, 1.6); }
      },
      unlock: function(){ ac(); }
    };
  })();

  /* [CTA] gros bloc vers la page pilier \u00ab Signification des 24 runes \u00bb + lien dans \u00ab Continue ton exploration \u00bb */
  function buildRunesCta(){
    if($("rntRunesCta")) return;
    var eng = document.querySelector(".rnt-engine"); if(!eng || !eng.parentNode) return;
    var glyphs = "";
    for(var i=0;i<RUNES.length;i++){
      glyphs += '<svg class="rnt-rc-g" style="animation-delay:'+(i*0.12).toFixed(2)+'s" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'+runeMarkup(RUNES[i].n, "#e7d4ac", 8)+'</svg>';
    }
    var sec = document.createElement("section");
    sec.className = "rnt-section"; sec.id = "rntRunesCta";
    sec.innerHTML = '<a class="rnt-bigcta rnt-bigcta-runes" href="https://www.astroya.fr/pages/signification-des-runes">'
      + '<span class="rnt-bigcta-glow">&#8203;</span><span class="rnt-bigcta-shimmer">&#8203;</span>'
      + '<span class="rnt-rc-glyphs" aria-hidden="true">'+glyphs+'</span>'
      + '<span class="rnt-bigcta-eyebrow">Ancien Futhark &middot; 24 runes</span>'
      + '<span class="rnt-bigcta-title">D\u00e9couvre la signification des 24 runes</span>'
      + '<span class="rnt-bigcta-sub">Chaque rune a sa page compl\u00e8te : sens \u00e0 l\u2019endroit et invers\u00e9, amour, travail, pierre align\u00e9e, rituel et pierre de galdr \u00e0 activer du bout du doigt.</span>'
      + '<span class="rnt-bigcta-btn">Explorer les 24 runes &rarr;</span></a>';
    eng.parentNode.insertBefore(sec, eng.nextSibling);
    var links = document.querySelector(".rnt-links");
    if(links && !links.querySelector('a[href*="signification-des-runes"]')){
      var a = document.createElement("a");
      a.href = "https://www.astroya.fr/pages/signification-des-runes";
      a.innerHTML = "&#5833; Signification des 24 runes";
      links.insertBefore(a, links.firstChild);
    }
    sec.addEventListener("mouseenter", function(){ SFX.hover(); }, false);
  }

  /* bouton son on/off, place sous la consigne du tirage */
  function buildSoundToggle(){
    if($("rntSoundBtn")) return;
    var ref = $("rntInstruction"); if(!ref || !ref.parentNode) return;
    var b = document.createElement("button");
    b.type = "button"; b.id = "rntSoundBtn"; b.className = "rnt-sound";
    function paint(){
      var o = SFX.isOn();
      b.innerHTML = (o ? "\uD83D\uDD0A Son &amp; vibrations" : "\uD83D\uDD07 Son coup\u00e9");
      b.setAttribute("aria-pressed", o ? "true" : "false");
      b.setAttribute("aria-label", o ? "Couper le son du tirage" : "Activer le son du tirage");
    }
    paint();
    b.addEventListener("click", function(ev){ ev.preventDefault(); SFX.setOn(!SFX.isOn()); paint(); if(SFX.isOn()){ SFX.hover(); } }, false);
    ref.parentNode.insertBefore(b, ref.nextSibling);
  }

  /* [LIENS] roue du bloc theme astral : 12 premieres runes du Futhark, chacune liee a sa page */
  function linkWheel(){
    var gs = document.querySelectorAll(".tdr-runes .tdr-r");
    if(!gs.length) return;
    var NS = "http://www.w3.org/2000/svg", XL = "http://www.w3.org/1999/xlink";
    for(var i=0;i<gs.length && i<RUNES.length;i++){
      var g = gs[i];
      if(g.getAttribute("data-linked")==="1") continue;
      var r = RUNES[i], url = runePageUrl(r.n);
      var tx = g.querySelector(".r-glyph");
      if(tx){ tx.textContent = r.g; }
      var a = document.createElementNS(NS, "a");
      a.setAttribute("href", url);
      a.setAttributeNS(XL, "xlink:href", url);
      a.setAttribute("class", "tdr-rlink");
      a.setAttribute("tabindex", "-1");
      var ti = document.createElementNS(NS, "title");
      ti.textContent = "Rune " + r.n;
      a.appendChild(ti);
      while(g.firstChild){ a.appendChild(g.firstChild); }
      g.appendChild(a);
      g.setAttribute("data-linked","1");
    }
  }

  /* [LIENS] styles des liens (injectes ici : aucune modif du CSS EComposer) */
  function injectLinkCss(){
    if(document.getElementById("rnt-links-css")) return;
    var css = ""
      + ".rnt-runeband{pointer-events:auto !important;}"
      + ".rnt-band-link{display:inline-flex !important; line-height:0 !important; text-decoration:none !important; border:none !important;}"
      + ".rnt-band-link:hover .rnt-band-rune,.rnt-band-link:focus .rnt-band-rune{opacity:.75 !important;}"
      + ".rnt-band-rune{transition:opacity .25s ease !important;}"
      + ".rnt-rlink{display:block !important; margin:12px auto 0 auto !important; font-family:Arial,sans-serif !important; font-size:14px !important; font-weight:bold !important; color:var(--rnt-or,#b08d4f) !important; text-decoration:underline !important; text-underline-offset:3px !important; cursor:pointer !important;}"
      + ".rnt-rlink:hover{color:var(--rnt-ardoise,#1f2c33) !important;}"
      + ".rnt-rlink-car{margin:14px 0 0 0 !important; font-size:15px !important;}"
      + "a.rnt-car-card{display:block !important; text-decoration:none !important; border:none !important;}"
      + ".tdr-scene .tdr-rlink{cursor:pointer !important;}"
      + ".tdr-scene .tdr-r,.tdr-scene .tdr-rlink{pointer-events:auto !important;}"
      + ".rnt-sound{display:block !important; margin:10px auto 0 auto !important; padding:7px 16px !important; font-family:Arial,sans-serif !important; font-size:14px !important; font-weight:bold !important; color:var(--rnt-ardoise,#2f3e46) !important; background:rgba(255,253,248,.85) !important; border:1px solid rgba(176,141,79,.45) !important; border-radius:999px !important; cursor:pointer !important; line-height:1.3 !important;}"
      + ".rnt-sound:hover{border-color:var(--rnt-or,#b08d4f) !important;}"
      + ".rnt-sound:focus-visible{outline:2px solid var(--rnt-or,#b08d4f) !important; outline-offset:2px !important;}"
      + ".rnt-sound[aria-pressed=false]{opacity:.7 !important;}"
      + ".rnt-bigcta-runes{background:linear-gradient(120deg,#0e1a2b 0%,#163a4a 30%,#1e9e75 62%,#3fd0ff 82%,#cdab6e 100%) !important; background-size:220% 220% !important; animation:rnt-cta-flow 11s ease infinite !important;}"
      + ".rnt-rc-glyphs{display:flex !important; flex-wrap:wrap !important; justify-content:center !important; gap:6px 8px !important; max-width:430px !important; margin:0 auto 14px auto !important; position:relative !important; z-index:2 !important;}"
      + ".rnt-rc-g{width:20px !important; height:20px !important; opacity:.55; animation:rnt-rc-tw 3.6s ease-in-out infinite;}"
      + "@keyframes rnt-rc-tw{0%,100%{opacity:.35; transform:translateY(0)}50%{opacity:1; transform:translateY(-3px)}}"
      + "@media (max-width:600px){.rnt-rc-g{width:16px !important; height:16px !important;}}"
      + "@media (prefers-reduced-motion:reduce){.rnt-rc-g{animation:none; opacity:.8}}";
    var st = document.createElement("style");
    st.id = "rnt-links-css";
    st.appendChild(document.createTextNode(css));
    document.head.appendChild(st);
  }

  /* ====== INIT ====== */
  var started = false;
  function tryInit(){
    if(started) return true;
    var mat = $("rntMat");
    if(!mat) return false;
    started = true;
    /* popup placee dans <body> : position:fixed fiable sous EComposer */
    var pm = $("rnmModal");
    if(pm && pm.parentNode !== document.body){ document.body.appendChild(pm); }
    buildSky();
    buildSeasonDecor();
    injectLinkCss();
    buildSoundToggle();
    buildRunesCta();
    buildRuneband();
    linkWheel();
    buildPile(); updateProgress(); updateCounter();
    return true;
  }
  tryInit();
  var tries = 0;
  var iv = setInterval(function(){ tries++; if(tryInit() || tries >= 24){ clearInterval(iv); } }, 250);
  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", tryInit); }
})();
} catch(error){console.error(error);}